import { Box } from 'components/library';
import styled from 'styled-components';

export const Container = styled(Box)`
    display: flex;
    align-items: center;
    flex-direction: column;
    height: 100%;
    padding: ${({ $paddingTop, $paddingBottom, $paddingX }) => `${$paddingTop}px ${$paddingX}px ${$paddingBottom}px `};
`;
